const style = {
  header: {
    color: "rgb(30, 131, 196)",
    marginLeft: "20px",
    marginTop: "20px",
    marginBottom: "10px",
  },

  borderleft: {
    marginTop: "1px",
    borderLeft: "2px solid lightgray",
  },
  img: {
    height: "5rem",
    marginTop: "0.5rem",
    width: "15rem",
  },
};

const Header = (props) => {
  return (
    <div className="row">
      <div className="col-2">
        <img src="Capgemini_logo.png" style={style.img} alt="Capgemini Logo" />
      </div>
      <div className="col" style={style.borderleft}>
        <div className="col" style={style.header}>
          <h3>
            <b>Translator</b>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Header;
